module.exports = __webpack_public_path__ + "static/media/blog3.8b5c0531.jpg";